import Header from '../components/Header';
import Footer from '../components/Footer';

const TermsConditions = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <article className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-gray-dark mb-6">
              Terms & Conditions
            </h1>
            
            <div className="text-sm text-gray-light mb-8">
              Last updated: 02.12.2025
            </div>
            
            <div className="prose prose-lg max-w-none text-gray-light leading-relaxed space-y-6">
              <p className="text-xl text-gray-medium">
                These Terms and Conditions govern your use of the Sceptre Slots website. By 
                accessing and using this website, you accept and agree to be bound by these 
                terms. If you do not agree with any part of these terms, you must not use our 
                website.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Acceptance of Terms</h2>
              
              <p>
                By accessing and using Sceptre Slots, you acknowledge that you have read, 
                understood, and agree to be bound by these Terms and Conditions. These terms 
                apply to all visitors, users, and others who access or use our website.
              </p>
              
              <p>
                We reserve the right to modify these terms at any time. Your continued use of 
                the website after any changes constitutes acceptance of the modified terms. 
                It is your responsibility to review these terms periodically for updates.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Age Restrictions</h2>
              
              <p>
                This website is intended for users aged 18 and over only. By using this website, 
                you represent and warrant that you are at least 18 years old and have the legal 
                capacity to enter into these terms. If you are under 18, you must not use this 
                website.
              </p>
              
              <p>
                Online gambling is restricted to individuals who have reached the legal age of 
                majority in their jurisdiction. It is your responsibility to ensure that online 
                gambling is legal in your location before accessing any casino websites through 
                our links.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Use of Website</h2>
              
              <p>
                You may use our website for lawful purposes only. You agree not to use the website 
                in any way that violates any applicable laws or regulations, infringes upon the 
                rights of others, or interferes with the operation of the website.
              </p>
              
              <p>
                You agree not to attempt to gain unauthorized access to any portion of the website, 
                other accounts, computer systems, or networks connected to the website. You also 
                agree not to use any automated systems, such as robots or spiders, to access the 
                website without our express written permission.
              </p>
              
              <p>
                We reserve the right to terminate or suspend your access to the website immediately, 
                without prior notice, for conduct that we believe violates these Terms and Conditions 
                or is harmful to other users, us, or third parties.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Content and Information</h2>
              
              <p>
                The information provided on this website is for general informational purposes only. 
                While we strive to provide accurate and up-to-date information, we make no 
                representations or warranties of any kind, express or implied, about the 
                completeness, accuracy, reliability, or suitability of the information.
              </p>
              
              <p>
                Casino reviews, bonus information, and other content are based on our research 
                and testing at the time of publication. However, casino terms, bonuses, and 
                conditions may change without notice. We recommend verifying current terms 
                directly with operators before making deposits or claiming bonuses.
              </p>
              
              <p>
                We are not responsible for any losses or damages resulting from reliance on 
                information provided on this website. Always gamble responsibly and within your 
                means.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Affiliate Relationships</h2>
              
              <p>
                Sceptre Slots operates as an independent review and comparison platform. Certain 
                links on our website are affiliate links, meaning we may receive a commission 
                if you click through or register through these links. This compensation does not 
                affect our editorial opinions, reviews, or ratings.
              </p>
              
              <p>
                Our affiliate relationships do not influence the content we create or the casinos 
                we review. We maintain editorial independence and provide honest, unbiased 
                information to help you make informed decisions.
              </p>
              
              <p>
                When you click on affiliate links, you will be redirected to third-party casino 
                websites. These websites have their own terms and conditions, privacy policies, 
                and responsible gambling policies. We are not responsible for the content or 
                practices of these third-party sites.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Intellectual Property</h2>
              
              <p>
                All content on this website, including text, graphics, logos, images, and software, 
                is the property of Sceptre Slots or its content suppliers and is protected by 
                copyright and other intellectual property laws.
              </p>
              
              <p>
                You may not reproduce, distribute, modify, create derivative works of, publicly 
                display, publicly perform, republish, download, store, or transmit any of the 
                material on our website without our prior written consent.
              </p>
              
              <p>
                You may print or download one copy of a reasonable number of pages from the 
                website for your own personal, non-commercial use, provided you do not modify 
                the content and retain all copyright notices.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Disclaimer of Warranties</h2>
              
              <p>
                The website is provided on an "as is" and "as available" basis. We make no 
                warranties, express or implied, regarding the website's operation or the 
                information, content, or materials included on the website.
              </p>
              
              <p>
                We disclaim all warranties, express or implied, including but not limited to 
                implied warranties of merchantability, fitness for a particular purpose, and 
                non-infringement. We do not warrant that the website will be uninterrupted, 
                secure, or error-free.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Limitation of Liability</h2>
              
              <p>
                To the fullest extent permitted by law, Sceptre Slots shall not be liable for 
                any indirect, incidental, special, consequential, or punitive damages, or any 
                loss of profits or revenues, whether incurred directly or indirectly, or any 
                loss of data, use, goodwill, or other intangible losses resulting from your 
                use of the website.
              </p>
              
              <p>
                Our total liability for any claims arising from or related to your use of the 
                website shall not exceed the amount you paid to us, if any, in the twelve months 
                preceding the claim.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Responsible Gambling</h2>
              
              <p>
                We are committed to promoting responsible gambling. If you feel that your 
                gambling is becoming problematic, we encourage you to seek help immediately. 
                Resources are available through organizations such as BeGambleAware, GamCare, 
                and GamStop.
              </p>
              
              <p>
                We recommend setting limits on your gambling activities, never gambling more 
                than you can afford to lose, and never chasing losses. Gambling should be 
                entertainment, not a way to make money or solve financial problems.
              </p>
              
              <p>
                If you need help with problem gambling, please visit BeGambleAware.org or 
                contact GamCare for support and advice.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Indemnification</h2>
              
              <p>
                You agree to indemnify, defend, and hold harmless Sceptre Slots, its officers, 
                directors, employees, and agents from and against any claims, liabilities, 
                damages, losses, and expenses, including reasonable legal fees, arising out of 
                or in any way connected with your use of the website or violation of these 
                Terms and Conditions.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Governing Law</h2>
              
              <p>
                These Terms and Conditions shall be governed by and construed in accordance with 
                the laws of England and Wales. Any disputes arising from or related to these 
                terms shall be subject to the exclusive jurisdiction of the courts of England 
                and Wales.
              </p>

              <h2 className="text-3xl font-bold text-gray-dark mt-12 mb-6">Contact Information</h2>
              
              <p>
                If you have any questions about these Terms and Conditions, please contact us at:
              </p>
              
              <p className="font-semibold">
                Email: info@sceptreslots.com<br />
                Phone: +44 8147 675 497<br />
                Address: London, United Kingdom
              </p>
            </div>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default TermsConditions;

